import { Injectable, signal } from "@angular/core";
import { Member, PrepaymentHistory, UsageHistory } from "../types/membership";
import { HttpClient } from "@angular/common/http";
import { ConfigService } from "./ConfigService";
import { AuthenticationService } from "./authentication.service";
import { MessageService } from "primeng/api";
import { TranslateService } from "@ngx-translate/core";
import { Observable } from 'rxjs';
import { UriApi } from "../helpers/UriApi";
import { Constants } from "../helpers/constants";
@Injectable({
  providedIn: "root",
})
export class MembershipService {
  api_getData = ConfigService.apiUrl + "/CustomerManagement/GetAll";
  api_postData= ConfigService.apiUrl + "/CustomerManagement/Post";
  api_deleteData = ConfigService.apiUrl + "/CustomerManagement/Delete";
  api_excute_sp = ConfigService.apiUrl + "/CustomerManagement/execute-sp";
  api_prepaid = ConfigService.apiUrl + "/PrepaidManagement/Post";
  
  constructor(
    private http: HttpClient,
    private messageService: MessageService,
    private translate: TranslateService,
    private auth: AuthenticationService,
  ) {}

  private members = signal<Member[]>([]);
  private prepaymentHistory = signal<PrepaymentHistory[]>([]);
  paymentType = Constants.paymentType;

  private usageHistory: UsageHistory[] = [
    {
      seqNo: "01",
      date: "2025-12-01",
      receiptNo: "0001",
      usedAmount: 30000,
      balance: 170000,
      category: "Normal",
    },
    {
      seqNo: "02",
      date: "2025-11-25",
      receiptNo: "0002",
      usedAmount: 45000,
      balance: 200000,
      category: "Normal",
    },
    {
      seqNo: "03",
      date: "2025-11-05",
      receiptNo: "0099",
      usedAmount: -10000,
      balance: 245000,
      category: "Return",
    },
  ];

body = {
    request: {
      jsonParams: {},
      data: "",
      dataList: "",
      menuCd: ''
    }
  };


  getPrepaymentHistory(param: any = {}) {
    this.body.request.jsonParams = param;
    return this.http.post(this.api_getData, this.body)
  }

  getUsageHistory() {
    return signal(this.usageHistory);
  }

  addMember(memberData: { name: string; phone: string; sms: string }) {
    this.members.update((members) => {
      const newId = (
        Math.max(...members.map((m) => parseInt(m.id, 10))) + 1
      ).toString();
      const newMember: Member = {
        id: newId,
        checked : false,
        customerNo: `123456789${Math.floor(1000 + Math.random() * 9000)}`,
        name: memberData.name,
        phone: memberData.phone,
        grade: "NORMAL",
        acc: 0,
        used: 0,
        avail: 0,
        count: 0,
        prepaid: 0,
        joinDate: new Date().toISOString().split("T")[0],
      };
      return [...members, newMember];
    });
  }

   addOrUpdateMember(member: any, userId: number, userName: string): Observable<any> {
    const isUpdate = !!member.MEMBER_NO;
    const payload = {
      Request: {
        UserId: userId,
        UserName: userName,
        JsonParams: {
          JsonData: {
            MEMBER_NO: isUpdate ? member.MEMBER_NO : "",
            MEMBER_ID: member.MEMBER_ID || '',
            MEMBER_NM: member.MEMBER_NM,
            HP_NO: member.HP_NO,
            SMS_YN: member.SMS_YN
          }
        },
        FunctionCode: 100,
        Option: 1, 
        CommandType: 1,
        Data: null,
        DataList: []
      }
    };
    return this.http.post(this.api_postData, payload);
  }

  /**
   * Process prepaid top-up payment
   * @param paymentData Payment details including member, amount, method, etc.
   * @param userId User ID
   * @param userName User name
   */
  /**
   * Delete member by setting USE_YN to 'N'
   * @param member Member data to delete
   * @param userId User ID
   * @param userName User name
   */
  deleteMember(member: any, userId: number, userName: string): Observable<any> {
    const payload = {
      Request: {
        UserId: userId,
        UserName: userName,
        JsonParams: {
          JsonData: [
            {
              MEMBER_NO: member.MEMBER_NO,
              MEMBER_ID: member.MEMBER_ID || "",
              MEMBER_NM: member.MEMBER_NM,
              HP_NO: member.HP_NO,
              SMS_YN: member.SMS_YN || "Y",
              USE_YN: "N"
            }
          ]
        },
        FunctionCode: 100,
        Option: 1,
        CommandType: 1,
        Data: null,
        DataList: []
      }
    };
    return this.http.post(this.api_deleteData, payload);
  }

  /**
   * Delete multiple members by setting USE_YN to 'N'
   * @param members Array of member data to delete
   * @param userId User ID
   * @param userName User name
   */
  deleteMembers(members: any[], userId: number, userName: string): Observable<any> {
    const jsonData = members.map(member => ({
      MEMBER_NO: member.MEMBER_NO,
      MEMBER_ID: member.MEMBER_ID || "",
      MEMBER_NM: member.MEMBER_NM,
      HP_NO: member.HP_NO,
      SMS_YN: member.SMS_YN || "Y",
      USE_YN: "N"
    }));

    const payload = {
      Request: {
        UserId: userId,
        UserName: userName,
        JsonParams: {
          JsonData: jsonData
        },
        FunctionCode: 100,
        Option: 1,
        CommandType: 1,
        Data: null,
        DataList: []
      }
    };
    return this.http.post(this.api_deleteData, payload);
  }

  processPrepaidPayment(paymentData: {
    memberNo: string;
    amount: number;
    paymentMethod: number;
    posNo?: string;
    installments?: number;
    receivedAmount?: number;
    additionalData?: any;
  }, userId: number, userName: string): Observable<any> {
    
    const currentDate = new Date();
    const dateStr = currentDate.getFullYear() + 
                    String(currentDate.getMonth() + 1).padStart(2, '0') + 
                    String(currentDate.getDate()).padStart(2, '0');
    
    // Map payment method to API format
    let chargeFg = 'Y'; // Y = Top-up, N = Return
    let apprFg = '0'; // Payment approval flag
    
    // Determine approval flag based on payment method
    // switch(paymentData.paymentMethod) {
    //   case 'CASH':
    //     apprFg = '1'; // Cash payment
    //     break;
    //   case 'CARD':
    //     apprFg = '2'; // Card payment
    //     break;
    //   case 'EASYPAY':
    //     apprFg = '3'; // EasyPay
    //     break;
    //   case 'BANK':
    //     apprFg = '4'; // Bank transfer / Points
    //     break;
    // }

    const payload = {
      UserId: userId,
      UserName: userName,
      FunctionCode: 100,
      Option: 1,
      CommandType: 1,
      JsonParams: null,
      Data: {
        MEMBER_NO: paymentData.memberNo,
        SAVE_CHARGE_DT: dateStr,
        POS_NO: paymentData.posNo || "01",
        CHARGE_FG: chargeFg,
        PAID_CHARGE_AMT: paymentData.amount,
        USE_YN: "Y",
        PREPAID_TYPE: paymentData.paymentMethod,
        APPR_FG :  paymentData.paymentMethod,
        APPR_AMT: paymentData.amount,
        SVC_AMT: 0,
        VAT_AMT: 0,
        USER_ID: String(userId).padStart(4, '0'),
        ...(paymentData.paymentMethod === this.paymentType.Card && paymentData.installments ? {
          INSTALLMENT_CNT: paymentData.installments
        } : {}),
        ...(paymentData.paymentMethod === this.paymentType.Cash && paymentData.receivedAmount ? {
          RECV_AMT: paymentData.receivedAmount,
          CHANGE_AMT: paymentData.receivedAmount - paymentData.amount
        } : {}),
        ...paymentData.additionalData
      },
      DataList: []
    };

    return this.http.post(this.api_prepaid, payload);
  }

   CancelTopup(param: any) {
      this.body.request.jsonParams = param;
      return this.http.post(UriApi.api_member_cancelTopup, this.body);
    }

}

